export default class PeachjarFileUploadError extends Error {
  constructor(public message: string) {
      super(message);
      Error.captureStackTrace(this, PeachjarFileUploadError);
  }
}
